import "./index.css"

import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom"

import { ApplicationLayout } from "@/components/layouts/ApplicationLayout"
import { ProtectedRoutes } from "@/components/routes/ProtectedRoutes"
import { ApplicationsPage } from "@/pages/ApplicationsPage"
import { CompareDocumentsPage } from "@/pages/CompareDocumentsPage"
import { CreateReportGeneratorPage } from "@/pages/CreateReportGeneratorPage"
import { DashboardPage } from "@/pages/DashboardPage"
import { DocumentPage } from "@/pages/DocumentPage"
import { NotFoundPage } from "@/pages/NotFoundPage"
import { ReportGeneratorPage } from "@/pages/ReportGeneratorPage"
import { ReportPage } from "@/pages/ReportPage"
import { SearchPage } from "@/pages/SearchPage"
import { SignInPage } from "@/pages/SignInPage"
import { UserSessionProvider } from "@/plugins/session/UserSessionProvider"

export default function App() {
  return (
    <UserSessionProvider>
      <BrowserRouter>
        <ApplicationLayout>
          <Routes>
            <Route path="/login" element={<SignInPage />} />
            <Route
                path="/*"
                element={
                  <ProtectedRoutes>
                    <Routes>
                      <Route path="/" element={<DashboardPage />} />
                      <Route path="/applications" element={<ApplicationsPage />} />
                      <Route path="/search" element={<SearchPage />} />
                      <Route path="/document/:id" element={<DocumentPage />} />
                      <Route path="/compare" element={<CompareDocumentsPage />} />
                      <Route path="/compare/:id" element={<CompareDocumentsPage />} />
                      <Route path="/report-generator" element={<ReportGeneratorPage />} />
                      <Route path="/report-generator/create" element={<CreateReportGeneratorPage />} />
                      <Route path="/report-generator/:id" element={<ReportPage />} />
                      <Route path="/404" element={<NotFoundPage />} />
                      <Route path="*" element={<Navigate to="/404" replace />} />
                    </Routes>
                  </ProtectedRoutes>
                }
              />
          </Routes>
        </ApplicationLayout>
      </BrowserRouter>
    </UserSessionProvider>
  )
}